import { withInstall } from '@xzx-design/utils'
import _Tabs from './src/tabs'

export const Tabs = withInstall(_Tabs)
export default Tabs

export * from './src/types/tabs'
export * from './src/types'
